import DaisyBaseService from './../../../services/DaisyBaseService';

export default class LoginDaisyService extends DaisyBaseService {

    constructor($injector) {
        super($injector);

        this.baseUrl = this.baseUrl + 'MDELogin/';
    }

    getPlants(){
        let functionUrl = 'GetPlants/';
        let data = {};

        return this.doPost(functionUrl, data);
    }

    getUserPlant(userName){
        let functionUrl = 'GetUserPlant/';
        let data = {
            'USER_NAME': userName
        };

        return this.doPost(functionUrl, data);
    }

    login(username, password, plantId){
        let functionUrl = 'Login/';
        let data = {
            'LOGIN_DATA': {
                'USER_NAME': username,
                'PIN': parseInt(password),
                'EVENT_NAME': this.eventName,
                'PLANT_ID': plantId
            }
        };

        return this.doPost(functionUrl, data);
    }
}